import { messageResponseHandler } from './handlers';
import { setToken, getToken } from './config';
import { MEMORY_STORAGE_MESSAGES, MESSAGE_TYPES } from '../constants';
import { Logger } from '../../app/helpers/logger';

export const sendReplyHandler =
  me =>
  ({ type, payload, metadata }) => {
    // memory storage messages are parte of our worker backbone communication,
    // as such have no topic to reply to
    if (!MEMORY_STORAGE_MESSAGES.includes(type) && !metadata?.topic) {
      throw new Error('missing topic');
    }

    me.postMessage({
      type,
      payload,
      metadata
    });
  };

export const onMessageHandler = me => async event => {
  const sendReply = sendReplyHandler(me);
  const message = event.data;
  Logger.debug('worker:onmessage', { type: message.type, data: message });

  if (!(message.type in MESSAGE_TYPES)) {
    Logger.info('worker: unexpected message received, ignoring');
    return;
  }

  // sometimes we lose persistence with the memory reference for transicsTokenHeader
  // maybe has something to do with the way web workers are implemented internally
  // regardless, we will always try to set the token, if we have it and it's not already defined
  const transicsUserProfileToken = message?.metadata?.transicsUserProfileToken;
  const token = getToken();
  if (!token && transicsUserProfileToken) {
    setToken(transicsUserProfileToken);
  }
  messageResponseHandler({ sendReply, message });
};
